import React, { useState, useEffect } from "react";
import { Card, CardBody, Modal } from "reactstrap";
import CountriesCodes from "assets/data/country_phone.json";
import constants from "constants";
import { useTranslation } from "context/TranslationProvider";
import ViewUploadedID from "modals/ViewUploadedID";

const UserCard = ({ user, title }) => {
  const { t } = useTranslation();
  const [countryPhoneCode, setCountryPhoneCode] = useState(null);
  const [pNum, setPNum] = useState("");
  const [modal, setModal] = useState(false);
  const [idUrl, setIdUrl] = useState(null);
  const [isImage, setIsImage] = useState(true);

  const toggleModal = () => setModal((prev) => !prev);

  const zoomImage = (url, imageFlag = true) => {
    setIdUrl(url);
    setIsImage(imageFlag);
    setModal(true);
  };

  useEffect(() => {
    if (user.phoneNumber) {
      const parts = user.phoneNumber.split(/\s+/);
      const number = parts.slice(1).join("").trim();
      const countryCode = CountriesCodes.find(
        (c) => c.phone === parts[0]?.trim()
      );

      setPNum(number);
      setCountryPhoneCode(countryCode || null);
    }
  }, [user.phoneNumber]);

  const initials = `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();

  const profileImageUrl = user.profilePictureUrl
    ? `${constants.s3Bucket}/profile-pics/${user.profilePictureUrl}`
    : null;

  return (
    <>
      <Card className="card-profile shadow mb-3">
        <CardBody className="text-center">
          <h5 className="mb-3 font-weight-bold text-md heading-md">{title}</h5>

          <div className="d-flex justify-content-center mb-3">
            {profileImageUrl ? (
              <img
                alt={user.firstName || t("table.row.user", "User")}
                src={profileImageUrl}
                className="user-profile-img cursor-pointer"
                onClick={() =>
                  zoomImage( profileImageUrl, true)
                }
              />
            ) : (
              <div className="user-initials">
                {initials || "U"}
              </div>
            )}
          </div>

          <h5 className="h3 mb-2 d-flex justify-content-center align-items-center">
            {user.firstName || "-"} {user.lastName || "-"}
          </h5>

            {user.email && (
              <div className="h5 font-weight-300 mb-1 d-flex justify-content-center align-items-center">
                {user.email}
              </div>
            )}

            {user.homeAddress && (
              <div
                className="h5 font-weight-300 mb-1 d-flex justify-content-center align-items-center card-user-address"
              >
                {user.homeAddress}
              </div>
            )}

            {user.phoneNumber && (
              <div className="h5 font-weight-300 mb-1 d-flex justify-content-center align-items-center mr-3">
                +{countryPhoneCode?.phone} {pNum}
              </div>
            )}

            {user.country?.name && (
              <div className="h5 font-weight-300 mb-1 d-flex justify-content-center align-items-center">
                {user.country.name}
              </div>
            )}
        </CardBody>
      </Card>
      <Modal isOpen={modal} toggle={toggleModal} centered size="lg">
        <ViewUploadedID
          idUrl={idUrl}
          isImage={isImage}
          isOpen={modal}
          toggle={toggleModal}
          isIdImage
        />
      </Modal>
    </>
  );
};

export default UserCard;
